module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture3-098cea761c955cbcfef4da46ea4a5443.jpg";